import { createApiClient } from "../../helpers/api-client";

/**
 * Create an API client for notification operations.
 *
 * @param {string} csrf - The CSRF token for authenticated requests.
 * @returns {{ fetchInitialNotifications: () => Promise<any>, fetchMoreNotifications: (uid: string) => Promise<any>, fetchMarkAllNotificationsAsRead: () => Promise<any>, fetchMarkNotificationAsRead: (uid: string) => Promise<any> }} The notifications API methods.
 */
export default function createNotificationsApi(csrf) {
    const api = createApiClient(csrf);

    return {
        /**
         * Fetch the initial batch of notifications.
         *
         * @returns {Promise<any>} The notifications response.
         */
        async fetchInitialNotifications() {
            return await api("/notifications/", "GET");
        },

        /**
         * Fetch more notifications starting after the given UID.
         *
         * @param {string} uid - The UID of the last loaded notification.
         * @returns {Promise<any>} The notifications response.
         */
        async fetchMoreNotifications(uid) {
            return await api(`/notifications/${uid}`, "GET");
        },

        /**
         * Mark all notifications as read.
         *
         * @returns {Promise<any>} The API response.
         */
        async fetchMarkAllNotificationsAsRead() {
            return await api(`/notifications/mark-all-as-read`, "POST");
        },

        /**
         * Mark a single notification as read.
         *
         * @param {string} uid - The UID of the notification to mark as read.
         * @returns {Promise<any>} The API response.
         */
        async fetchMarkNotificationAsRead(uid) {
            return await api(`/notifications/${uid}/mark-as-read`, "POST");
        },
    };
}
